import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Http } from "@angular/http";
import { AccountInfoEndpoint } from "@app/services/account-info/account-info-endpoint.service";
import { AccountInfoModel } from "@app/models/account-info/myAccountInfoModel";
import { Observable } from "rxjs";
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';



@Injectable()
export class AccountInfoService {
    constructor(private router: Router,
        private http: Http,
        private accountInfoEndpoint: AccountInfoEndpoint) { }

    getAccountInfo(IsDashboardCall: boolean) {
        return this.accountInfoEndpoint.getAccountInfo(IsDashboardCall);
    }

    getCardNumber() {

        return this.accountInfoEndpoint.getCardNumber();
    }

    getCustomerCardByCustomerCode(CustomerCode: string) {

        return this.accountInfoEndpoint.getCustomerCardByCustomerCode(CustomerCode);
    }

    getAcquirerDetails() {
        return this.accountInfoEndpoint.getAcquirerDetails();
    }
    getDetailsMerchant(EntityId:number) {
        return this.accountInfoEndpoint.getDetailsMerchant(EntityId);
    }
    getProgramDetails(){
        return this.accountInfoEndpoint.getProgramDetails();
    }
}




// WEBPACK FOOTER //
// ./src/app/services/account-info/account-info.service.ts